import React, { useRef, useState, useEffect } from 'react';
import '../futurecuex/future.scss'
import appLogo from '../../assets/img/icon_future_logo.png'
import appJietu from '../../assets/img/icon_app_jietu.png'
import android from '../../assets/img/icon_android.png'
const futurecuex = () => {
    return (
        <div className='future'>
            <div className='future_body'>
            <img className='appLogo' src={appLogo}></img>
            <h1>Future</h1>
            <p className='subtitle'>Explore the future, unlock the guidance of destiny</p>
            <img className='appJietu' src={appJietu}></img>
            <a href='https://obj-web-prod.s3.us-west-1.amazonaws.com/app_futurecuex/future_app_release.apk'>
                <div className='download'>
                    <img width={17} height={17} src={android}></img>
                    <p className='downloadText'>future for <strong>Android</strong></p>
                </div>
            </a>
            <p className='title'>Why choose Future?</p>
            <span className='titleDesc'>
            Future is your ideal choice for exploring the future and unlocking destiny. Whether you are a fortune teller enthusiast or curious about the future, Future will provide you with the most comprehensive and thoughtful fortune telling services.
            </span>
            </div>
        </div>
    );
};

export default futurecuex;
